import { Text, TextType } from 'ui-components/components/text';

import { FeatureCard } from './feature-card';
import { featureCardsData } from './feature-cards-data';
import style from './style.module.less';
import messages from './messages';

export const FeatureCardCollection = () => {
  return (
    <div className={style['feature-cards-list']}>
      <Text className={style['feature-cards-title']} textType={TextType.H4} value={messages.featureSectionTitle} />
      {featureCardsData.map((card) => (
        <FeatureCard key={card.id} card={card} />
      ))}
    </div>
  );
};
